const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatDollars(amount: number | null | undefined, empty = '-'): string {
  if (amount == null || Number.isNaN(Number(amount))) return empty;
  return usd.format(Number(amount));
}

export function roundCents(amount: number): number {
  return Math.round(amount * 100) / 100;
}
